import React, { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { SectionWrap } from '../../Components';
import LoadingPage from '../LoadingPage/LoadingPage';


function EditMember() {
    // const apiUrl = 'http://localhost/server/testServer/team.php';
    const apiUrl = 'https://www.albarede.com/server/team.php';
    const { id } = useParams();
    const [title, setTitle] = useState('');
    const [position, setPosition] = useState('');
    const [disc, setDisc] = useState('');
    const [files, setFiles] = useState(null);
    const [email, setEmail] = useState('');
    const [redirect, setRedirect] = useState(false);
    const [isLoading, setIsLoading] = useState(true); // حالة التحميل

    // Fetch data by ID
    useEffect(() => {
        setIsLoading(true);
        fetch(`${apiUrl}?id=${id}`)
            .then((response) => response.json())
            .then((data) => {
                if (data && !data.error) {
                    setTitle(data.title || '');
                    setPosition(data.position || '');
                    setDisc(data.disc || '');
                    setEmail(data.email || '');
                    setIsLoading(false);
                } else {
                    console.error('Error fetching data:', data.error);
                }
            })
            .catch((err) => console.error('Error fetching team:', err));
    }, [id]);

    // Update member details
    const updatePost = async (ev) => {
        ev.preventDefault();
    
        if (!title || !position || !disc || !email) {
            alert('Please fill out all required fields.');
            return;
        }
    
        const postData = {
            title,
            position,
            disc,
            email
        };
    
        try {
            const response = await fetch(`${apiUrl}?id=${id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(postData),
            });
    
            if (!response.ok) {
                const error = await response.json();
                alert(`Error: ${error.error || 'Something went wrong'}`);
                return;
            }
    
            alert('تم تعديل المقال بنجاح');
            setRedirect(true);
        } catch (err) {
            console.error('Error updating post:', err);
            alert('Failed to update post.');
        }
    };
    

    // Delete member
    const deleteTeam = async () => {
        const confirmDelete = window.confirm('هل أنت متأكد أنك تريد الحذف؟');
        if (!confirmDelete) return;

        try {
            const response = await fetch(`${apiUrl}?id=${id}`, {
                method: 'DELETE',
            });

            if (!response.ok) {
                const error = await response.json();
                alert(`Error: ${error.error || 'Failed to delete member'}`);
                return;
            }

            alert('تم الحذف بنجاح');
            setRedirect(true);
        } catch (err) {
            console.error('Error deleting member:', err);
        }
    };

    if (redirect) {
        return <Navigate to={'/team'} target='_top'/>;
    }
    if (isLoading) {
        return <LoadingPage />; // عرض صفحة التحميل أثناء التحميل
      }

    return (
        <div className="createPost">
            <SectionWrap>
                <form className="createFormPost" onSubmit={updatePost}>
                    <h1>تعديل العضو</h1>
                    <input
                        type="text"
                        placeholder="الاسم"
                        value={title}
                        onChange={(ev) => setTitle(ev.target.value)}
                    />
                    <input
                        type="text"
                        placeholder="الصفة"
                        value={position}
                        onChange={(ev) => setPosition(ev.target.value)}
                    />
                    <textarea
                        placeholder="ملخص الخبرات"
                        value={disc}
                        onChange={(ev) => setDisc(ev.target.value)}
                    />
                    <input
                        type="email"
                        placeholder="البريد الإلكتروني"
                        value={email}
                        onChange={(ev) => setEmail(ev.target.value)}
                    />
                    <button type="submit" className="postBtn">حفظ التعديلات</button>
                    <button type="button" onClick={deleteTeam} className="postBtnDelet">حذف</button>
                </form>
            </SectionWrap>
        </div>
    );
}

export default EditMember;
